import React, {useState} from 'react'
import {useAtom, useCtx} from '@reatom/npm-react'
import './style.css'
import {getPlayerName, requestsAtom, requestSliceAtom} from '../model'
import MembersItem from './MembersItem'
import {motion, AnimatePresence} from 'motion/react'
import SvgSprite from '../../Utils/SvgSprite'
import cn from 'classnames'
import { atom } from '@reatom/core'

const orderAtom = atom({
  key: null,
  order: 'DESC'
})

function Orderable({label, onOrder = null}){  

  const [sort, setSort] = useAtom(orderAtom)

  const ctx = useCtx()

  function compareDESC(a, b){
    return a > b
  }

  function compareASC(a, b){
    return a < b
  }

  return (
    <span className={cn(
      'orderable', 
      {'-active': sort.key==label},
      {'-desc': sort.key==label && sort.order=='DESC'},
      {'-asc': sort.key==label && sort.order=='ASC'},
    )} onClick={()=>{
      const sort = ctx.get(orderAtom)
      // console.log(sort.order)
      let order = 'DESC'
      if(sort.key == label){
        order = sort.order == 'DESC' ? 'ASC' : 'DESC'
      }
      setSort({
        key: label,
        order: order,
      })
      if(onOrder){
        // const compare = sort.order == 'DESC' ? (a, b) => a > b : (a, b) => a < b
        onOrder(order == 'DESC' ? compareDESC : compareASC)
      }
    }}>
      {label}
      <SvgSprite id="arrow_down" />
    </span>
  )
}

function MembersTable({}) {
  const [all_shown, setAllShown] = useState(false)

  const [order, setOrder] = useState()

  useAtom(orderAtom)

  function toggleAll() {
    setAllShown(!all_shown)
  }
  const ctx = useCtx()

  const [requests,] = useAtom(requestsAtom)
  const [requests_slice,] = useAtom(requestSliceAtom)

  let current_requests = requests_slice
  if (all_shown) {
    current_requests = requests
  }

  return (
    <div className="members-table">
      <div className="sub-heading">Заявки на турнир</div>
      <table className="table -th-no-breakable">
        <tbody>
        <tr>
          <th>№</th>
          <th>Фото</th>
          <th>
            <Orderable 
              label="ФИО"
              onOrder={(compare) => {
                // requestsAtom(ctx, [...ctx.get(requestsAtom).sort((a, b)=>{})])
                requestsAtom(ctx, [...ctx.get(requestsAtom).sort((a, b)=>{
                    const lower_a = getPlayerName(a.player).toLowerCase()
                    const lower_b = getPlayerName(b.player).toLowerCase()
                    // return lower_a > lower_b
                    return compare(lower_a, lower_b)
                })])
              }}
            />
          </th>
          <th className="f-d-lg-table-cell f-d-none">
            <Orderable 
              label="ГР"
              onOrder={(compare) => {
                requestsAtom(ctx, [...ctx.get(requestsAtom).sort((a, b)=>{
                    return compare(a.player.birth_date, b.player.birth_date)
                    // return a.player.birth_date > b.player.birth_date
                })])
              }}
            />
          </th>
          <th className="f-d-lg-table-cell f-d-none">Разряд</th>
          <th className="f-d-lg-table-cell f-d-none">
            <Orderable 
              label="Субъект РФ" 
              onOrder={(compare) => {
                requestsAtom(ctx, [...ctx.get(requestsAtom).sort((a, b)=>{
                    // return a.player.region > b.player.region
                    return compare(a.player.region, b.player.region)
                })])
              }}
            />
          </th>
          <th></th>
        </tr>
        <AnimatePresence initial={false}>
          {current_requests.map((item, i) => (
            <MembersItem
              num={i + 1}
              key={item.player.id}
              // key={i}
              source={item}
            />
          ))}
        </AnimatePresence>
        </tbody>
      </table>
      <div className="members-table__buttons">
        {requests.length > requests_slice.length && (
          <div className="button -link-big" onClick={toggleAll}>
            {all_shown && (
              'Скрыть'
            ) || (
              'Показать все'
            )}
          </div>
        )}
      </div>
    </div>
  )
}


export default MembersTable